import { MessageCircle, MapPin } from "lucide-react";
import { ADDRESS, DEFAULT_WA, WHATSAPP_DISPLAY } from "../../lib/api";
import { Reveal } from "../../lib/motion";

export default function Contact() {
  return (
    <section
      id="contato"
      data-testid="contact-section"
      className="relative bg-crimson text-paper overflow-hidden py-24 lg:py-32"
    >
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-crimson-deep blur-[120px] opacity-70" />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-paper/70">
            Pré-análise gratuita
          </p>
          <h2 className="mt-6 font-display font-extrabold tracking-tightest text-5xl md:text-8xl leading-[0.95]">
            Fale
            <br />
            conosco.
          </h2>
          <p className="mt-7 text-paper/80 text-base md:text-lg max-w-xl mx-auto">
            Sua contabilidade está funcionando? Está no regime tributário
            correto? Invista em uma consultoria minuciosa e tenha a{" "}
            <span className="font-semibold text-paper">certeza</span> de que sua
            empresa está no caminho certo.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <a
            data-testid="contact-whatsapp-cta"
            href={DEFAULT_WA}
            target="_blank"
            rel="noreferrer"
            className="mt-11 inline-flex items-center gap-3 bg-paper text-ink font-display font-bold text-2xl md:text-4xl px-10 py-6 rounded-full transition-all duration-300 hover:scale-[1.03] hover:bg-white shadow-2xl"
          >
            <MessageCircle size={30} className="text-crimson" />
            {WHATSAPP_DISPLAY}
          </a>
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-paper/70">
            <MapPin size={15} />
            {ADDRESS}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
